module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img_center"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_008.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('p', {
    staticClass: "hright1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("Crocheted bobbles and diamond cables come together to make this sweet, feminine cardigan. The yoke, front panels, and all the edges are defined by the bobbles, which are inspired by the pebble beaches on Ireland’s southernmost inhabited island, Cleire.")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("SIZES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("3 (6, 9, 12, 18, 24) months")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("FINISHED MEASUREMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("18 (19¼, 20, 22, 24, 26)\" chest")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("YARN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Berroco Comfort DK (50% super fine nylon / 50% super fine acrylic; 50 grams / 178 yards): 3 (3, 3, 3, 4, 4) skeins #2703 Barley")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("CROCHET HOOKS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Crochet hook size US H/8 (5 mm)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Change hook size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("NOTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Stitch markers; two ½\" buttons")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("GAUGE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("20 sts and 20 rows = 4\" (10 cm) in Single Crochet (sc)")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_c('b', [_vm._v("FPdc:")]), _vm._v(" Yo, insert hook from front to back to front around post of indicated st, yo and pull up a loop, [yo and pull through 2 loops on hook] twice.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_c('b', [_vm._v("FPdc decrease:")]), _vm._v(" Yo, insert hook from front to back to front around post of first skipped FPdc, yo and pull up a loop, yo and draw through 2 loops on hook; yo, insert hook from front to back to front around post of next skipped FPdc, yo and pull up a loop, yo and draw through 2 loops on hook, yo and draw through all 3 loops on hook.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_c('b', [_vm._v("Popcorn:")]), _vm._v(" Work 5 sc in next sc, drop loop from hook, insert hook in first sc of this 5-sc group then through dropped loop, draw dropped loop through st. Ch 1 to close (ch does not count as a st).")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "pink"
  }, [_c('b', [_vm._v("Sc2tog:")]), _vm._v(" Pull up a loop in each of next 2 sc, yo and pull through both loops on hook.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("STITCH PATTERNS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("SINGLE CROCHET")]), _vm._v(" (any number of sts + 1 ch; 1-row repeat)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" Sc in second ch from hook and in each ch to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 2:")]), _vm._v(" Ch 1, sc in each sc to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Repeat Row 2 for Single Crochet.")]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('b', [_vm._v("BORDER POPCORN PATTERN")]), _vm._v(" (odd number of sts + 1 ch; 4 rows)")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 1 (RS):")]), _vm._v(" Sc in second ch from hook and in each ch to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 2:")]), _vm._v(" Ch 1, sc in each sc to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 3:")]), _vm._v(" Ch 1, sc in first sc, *popcorn in next sc, sc in next sc; repeat from * to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 4:")]), _vm._v(" Ch 1, sc in each st to end.")])]), _c('p', {
    staticClass: "normalt"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('b', [_vm._v("CABLE PATTERN")]), _vm._v(" (panel of 17 sts; 42 rows)")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("Note: Ch 1 at the beginning of every row when working Cable Pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 1:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 4 sc, work FPdc around next sc 2 rows below, FPdc around next popcorn 2 rows below, skip 2 sc behind 2 FPdc just made, sc in next sc, work FPdc around same popcorn as last FPdc, work FPdc around next popcorn 2 rows below, skip 2 sc behind FPdc just made, sc in next 4 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 2 and all WS rows:")]), _vm._v(" Sc in each sc across.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 3:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 3 sc, work FPdc around each of next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next sc, popcorn in next sc, sc in next sc, work FPdc around each of next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 3 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 5:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 5 sc, work FPdc around each of first 2 FPdc 2 rows below, work FPdc around next 2 FPdc 2 rows below, skip 3 sc behind FPdc just made, sc in next 5 sc, popcorn in next sc, sc in last sc—18 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 7:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 4 sc, work FPdc around third and fourth FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next sc, working in front of 2 FPdc just made, work FPdc around each 2 skipped FPdc, skip 3 sc behind FPdc just made, sc in next 4 sc, popcorn in next sc, sc in last sc—17 sts remain.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 9:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 3 sc, work FPdc around next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 3 sc, work FPdc around next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 3 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 11:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 2 sc, work FPdc around next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 5 sc, work FPdc around next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 2 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 13:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next sc, work FPdc around next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 7 sc, work FPdc around next 2 FPdc, skip 2 sc behind FPdc just made, sc in next sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 15:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 2 sc, work FPdc around each of first 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 5 sc, work 2 FPdc in next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 2 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 17:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 3 sc, work FPdc around each of first 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 3 sc, work 2 FPdc in next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 3 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 19:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 4 sc, work FPdc around each of first 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next sc, work 2 FPdc in next 2 FPdc 2 rows below, skip 2 sc behind FPdc just made, sc in next 4 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 21:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 5 sc, work FPdc around third and fourth FPdc 2 rows below, working in front of FPdc just made, work FPdc decrease, skip 3 sc behind FPdc just made, sc in next 5 sc, popcorn in next sc, sc in last sc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 23:")]), _vm._v(" Sc in first sc, popcorn in next sc, sc in next 5 sc, work FPdc around next 2 FPdc 2 rows below, work 2 FPdc around next FPdc decrease 2 rows below, skip 3 sc behind FPdc just made, sc in next 5 sc, popcorn in next sc, sc in last sc—18 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Row 24:")]), _vm._v(" Work 1 sc in each st across.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rows 25-42:")]), _vm._v(" Repeat Rows 7-24.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("BODY")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("Note: Sweater is worked back and forth in one piece.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Ch 112 (118, 122, 132, 142, 152).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Begin Border Popcorn Pattern; work even for 3 rows—111 (117, 121, 131, 141, 151) sts remain.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Next Row (WS):")]), _vm._v(" Ch 1, sc in each st to last 2 sts, sc2tog over last 2 sts, turn—110 (116, 120, 130, 140, 150) sts remain. Place markers 28 (29, 30, 33, 35, 38) sts in from each edge.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Next Row:")]), _vm._v(" Work Cable Pattern over first 17 sts, sc across to last 17 sts, work Cable Pattern to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Next Row:")]), _vm._v(" Ch 1, sc in each st to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('b', [_vm._v("SHAPE SIDES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row (RS):")]), _vm._v(" Work Cable Pattern over 17 sts, [sc across to 2 sts before marker, sc2tog over next 2 sts, sm, sc2tog over next 2 sts], sc across to last 17 sts, work Cable Pattern to end, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Repeat Decrease Row every 6 rows twice, then every 4 rows twice—90 (96, 100, 110, 120, 130) sts remain.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Work even until piece measures approximately 6\" from the beginning, ending with a RS row.")])]), _c('p', {
    staticClass: "sh1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('b', [_vm._v("SHAPE YOKE")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Next Row (WS):")]), _vm._v(" Ch 1, sc across to first marker, ch 31 (31, 35, 35, 37, 37) (for first armhole), sc across to second marker, ch 31 (31, 35, 35, 37, 37) (for second armhole), sc in each st to end, turn—152 (158, 170, 180, 194, 204) sts. Work even for body, and for sleeves, begin Border Popcorn Pattern; work even for 4 rows.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 1 (RS):")]), _vm._v(" Work Cable Pattern over 17 sts, work 1 (4, 3, 1, 1, 6) sc, sc2tog over next 2 sts, [work 5 sc, sc2tog over next 2 sts] 16 (16, 18, 20, 22, 22) times, work 1 (4, 3, 1, 1, 6) sc, sc2tog over next 2 sts, work Cable Pattern to end, turn —134 (140, 150, 158, 170, 180) sts remain. Work even for 3 rows.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 2 (RS):")]), _vm._v(" Work Cable Pattern over 17 sts, work 0 (4, 4, 3, 5, 9) sc, [work 3 sc, sc2tog over next 2 sts] 19 (19, 21, 23, 25, 25) times, work 5 (7, 7, 6, 6, 12) sc, work Cable Pattern to end, turn—115 (121, 129, 135, 145, 155) sts remain. Work even for 1 row.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 3 (RS):")]), _vm._v(" Work Cable Pattern over 17 sts, work 1 (4, 4, 3, 4, 9) sc, [sc2tog over next 2 sts, work 2 sc] 20 (20, 22, 24, 26, 26) times, work 0 (3, 3, 2, 3, 8) sc, work Cable Pattern to end, turn—95 (101, 107, 111, 119, 129) sts remain. Work even for 1 row.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 4 (RS):")]), _vm._v(" Work Row 3 of Border Popcorn Pattern, dec 10 (12, 14, 16, 20, 24) sts evenly spaced across (by working sc2tog in place of 1 sc), turn—85 (89, 93, 95, 99, 105) sts remain. Work even for 1 (1, 1, 3, 3, 5) row(s).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Buttonhole Row (RS):")]), _vm._v(" Ch 1, sc in first 2 sc, ch 2, skip next 2 sc, sc in each sc to end, turn. Work even for 1 row, working 2 sc in ch-2 sp.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 5 (RS):")]), _vm._v(" Ch 1, sc in each sc to end, decrease 5 (5, 5, 7, 5, 5) sc evenly spaced across, turn—80 (84, 88, 88, 94, 100) sts remain. Work even for 1 (1, 1, 3, 3, 5) row(s).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 6 (RS):")]), _vm._v(" Work 5 (0, 6, 1, 6, 6) sc, [work 2 (2, 1, 2, 1, 1) sc, sc2tog over next 2 sts] 17 (21, 25, 21, 27, 29) times, work 7 (0, 7, 3, 7, 7) sc—63 (63, 63, 67, 67, 71) sts remain. Work even for 1 row.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Next Row (RS):")]), _vm._v(" Work Row 3 of Border Popcorn Pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Work even for 1 row.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Repeat Buttonhole Row. Work even for 1 row, working 2 sc in ch-2 sp.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Fasten off.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("FINISHING")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Fold first 2 Border Popcorn Pattern to WS and sew in place, being careful not to let sts show on RS. Sew buttons opposite buttonholes.")]), _vm._v(" "), _c('p', {
    staticClass: "img_center1"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_011.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8bc2ed8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 72
// module chunks = 0